import React from 'react'
import { SingleButton } from '../../../../API/Buttons/models'

export const StaticsVariantsHelpers = ({ selectedButton }: { selectedButton: SingleButton | null }) => {
    if (!selectedButton) return null
    return (
        <div className='text-secondary'>

            {selectedButton?.name === 'static_bonus' && <div><code>__BONUS__</code> Bonus porcentual de la carga.</div>}


            {selectedButton?.name === 'static_bonus' && <div><code>__CANTIDAD__</code> Cantidad de fichas cargadas.</div>}
            {selectedButton?.name === 'static_add' && <div><code>__CANTIDAD__</code> Cantidad de fichas cargadas.</div>}
            {selectedButton?.name === 'static_subtract' && <div><code>__CANTIDAD__</code> Cantidad de fichas bajadas.</div>}

            {selectedButton?.name === 'static_add' && <div><code>__USUARIO__</code> Nombre del usuario que recibió las fichas.</div>}
            {selectedButton?.name === 'static_subtract' && <div><code>__USUARIO__</code> Nombre del usuario que bajó las fichas.</div>}
            {selectedButton?.name === 'static_newuser' && <div><code>__USUARIO__</code> Nombre del usuario que se creó.</div>}
            {selectedButton?.name === 'static_unblock' && <div><code>__USUARIO__</code> Nombre del usuario que se desbloqueó.</div>}
            {selectedButton?.name === 'static_reset' && <div><code>__USUARIO__</code> Nombre del usuario que se reestableció.</div>}
            {selectedButton?.name === 'static_bonus' && <div><code>__USUARIO__</code> Nombre del usuario que recibió las fichas.</div>}

            {selectedButton?.name === 'static_newplayerbyemail' && <div><code>__USUARIO__</code> Usuario creado en la plataforma.</div>}

            {selectedButton?.name === 'static_newplayerbyemail' && <div><code>__JUGADOR__</code> Primer nombre del jugador creado.</div>}
            {selectedButton?.name === 'static_newplayerbyemail' && <div><code>__EMAIL__</code> Email del jugador que se creó en Gestor.</div>}
            {selectedButton?.name === 'static_newplayerbyemail' && <div><code>__GESTORPASSWORD__</code> Password del jugador en Gestor.</div>}
            {selectedButton?.name === 'static_newplayerbyemail' && <div><code>__GESTORURL__</code> URL de tu web Gestor.</div>}
            {selectedButton?.name === 'static_newplayerbyemail' && <div><code>__NOMBREPUBLICO__</code> Nombre público de tu Gestor.</div>}


        </div>
    )
}
